import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../core/services/core.user.service';

import * as _ from 'lodash';

const template = `<span class="badge reminder-badge {{labelClass}}">
<span *ngIf="reminder" 
    gf-popover="<h4>{{reminder.label}}</h4><strong>Reminder On:</strong>&nbsp;{{reminder.targetDate | gfDate:'ll'}}<br /><strong>By:</strong>&nbsp;{{reminder.user | fullName}}<p class='comment'>{{reminder.comments}}</p><p class='sent-notice'><i>This reminder has been sent</i></p>" 
    placement="left" allow-click-event="true" 
    (click)="resetDelete">
    <img class="avatar avatar-sm" [src]="reminder.user | avatar" />
    <span class="reminder-label">{{reminder.label}}</span>
</span>
<span class="delete-buttons" *ngIf="reminder.status == 0">
    <i class="glyphicon glyphicon-check"></i>
</span>
<span class="delete-buttons" *ngIf="showDeleteReminder">
    <span *ngIf="! markedForDelete">
        <i class="glyphicon glyphicon-trash"
            (click)="markedForDelete = true"
        ></i>
    </span>
    <span *ngIf="markedForDelete">
        <i class="glyphicon glyphicon-trash text-danger"
            [title]="'Delete this reminder' | translate"
            (click)="deleteReminderCallback.emit(reminder)"
        ></i>

        <i class="glyphicon glyphicon-remove"
            [title]="'Cancel deletion of this reminder' | translate"
            (click)="markedForDelete = false"
        ></i>
    </span>
</span>
</span>`
@Component({
    selector: 'gf-reminder-badge',
    template: template
})
export class ReminderBadgeComponent implements OnInit {

    @Input() reminder: any = null;

    @Input() allowDelete: any = false;

    @Output() deleteReminderCallback = new EventEmitter<any>();

    private currentUser = null;
    protected markedForDelete = false;
    protected showDeleteReminder = false;
    protected labelClass: string = 'inactive';

    constructor(private userService: UserService) { }
        
    ngOnInit() {      
        this.currentUser = this.userService.session.getUser();
        const status = _.get(this, 'reminder.status', 0);
        if (status > 0) {
            this.labelClass = 'active'
            this.showDeleteReminder = (
                this.allowDelete &&
                (_.get(this, 'reminder.user.id', 0) == this.currentUser.id)
            );
        }
    }

    resetDelete() {
        this.markedForDelete = false;
    }
}